import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Map descriptive currency names to ISO codes
const currencyMap = {
  'PESOS MXN': 'MXN',
  'MXN': 'MXN',
  'DÓLARES': 'USD',
  'USD': 'USD',
  'EUROS': 'EUR',
  'EUR': 'EUR',
  'UDI': 'MXN', // UDI uses MXN format but is a Mexican unit
};

export function formatCurrency(amount, currency = 'MXN') {
  // Convert descriptive name to ISO code
  const isoCode = currencyMap[currency] || currency;
  
  // Special handling for UDI
  if (currency === 'UDI') {
    return new Intl.NumberFormat('es-MX', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount) + ' UDI';
  }
  
  try {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: isoCode,
    }).format(amount);
  } catch (error) {
    // Fallback if currency code is not recognized
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN',
    }).format(amount);
  }
}

export function formatDate(dateString) {
  if (!dateString) return '';
  
  // Formato DD/MM/YYYY (usado en México)
  if (dateString.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
    const [day, month, year] = dateString.split('/');
    const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    return date.toLocaleDateString('es-MX');
  }
  
  // Formato YYYY-MM-DD (ISO)
  if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
    const [year, month, day] = dateString.split('-');
    const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    return date.toLocaleDateString('es-MX');
  }
  
  // Si tiene componente de tiempo, usar el método estándar
  const date = new Date(dateString);
  return date.toLocaleDateString('es-MX');
}
